import { apiV2Root } from "consts";
import type { RestrictionType } from "features/restrictions/data/types";
import { useState } from "react";

export function useSetRestriction(onDone?: () => void) {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setRestriction = async (
    userId: number,
    restrictionType: RestrictionType,
    reason: string,
    expiresAt: string | null,
  ) => {
    if (isSaving) return;

    setIsSaving(true);
    setError(null);

    try {
      const response = await fetch(`${apiV2Root}restrictions/set/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          userId,
          restrictionType,
          reason,
          expiresAt,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || `Request failed: ${response.status}`);
      }

      onDone?.();
    } catch (e: any) {
      setError(e?.message || "Unknown error");
    } finally {
      setIsSaving(false);
    }
  };

  return { isSaving, error, setRestriction };
}
